import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import PostHogProvider from "../components/PostHogProvider";
import NotFound from "../pages/NotFound";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
	component: RootComponent,
	notFoundComponent: NotFound,
});

function RootComponent() {
	return (
		<PostHogProvider>
			<Outlet />
		</PostHogProvider>
	);
}
